import { useState, useEffect } from 'react';

export default function useBot(
  enabled,
  player2Cards,
  setPlayer2Cards,
  player2Deck,
  setPlayer2Deck,
  leftDeck,
  setLeftDeck,
  rightDeck,
  setRightDeck,
  canMoveToDeck,
  moveToDeck,
  canMoveToGameDeck,
  moveToGameDeck,
  canPickUpDeck,
  pickUpDeck,
  status,
  pushXimiXurri,
  isXimiXurri
) {
  const [round, setRound] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => setRound(true), 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!enabled || !round) {
      return;
    }
    const fillDeck = () => {
      const cardSlot = player2Deck.find(card => card.special === 'slot');
      if (cardSlot && canMoveToDeck({ player: 2 }, player2Cards, cardSlot, 2)) {
        moveToDeck(
          setPlayer2Cards,
          setPlayer2Deck,
          player2Deck.indexOf(cardSlot)
        );
      }
    };

    const play = () => {
      const playable = player2Deck.filter(card => card.special !== 'slot');
      for (let i = playable.length; i--; ) {
        const card = playable[i];
        const item = {
          card,
          index: player2Deck.indexOf(card),
          player: 2
        };
        if (canMoveToGameDeck(item, leftDeck)) {
          moveToGameDeck(item, setLeftDeck);
          break;
        } else if (canMoveToGameDeck(item, rightDeck)) {
          moveToGameDeck(item, setRightDeck);
          break;
        }
      }
    };

    const check = () => {
      if (isXimiXurri()) {
        pushXimiXurri(2);
      } else if (status === 'blocked') {
        if (leftDeck.length <= rightDeck.length) {
          if (
            leftDeck[leftDeck.length - 1].special !== 'slot' &&
            canPickUpDeck({ idDeck: 'left' }, 2)
          ) {
            pickUpDeck('left', setPlayer2Cards, 2);
          } else if (
            rightDeck[rightDeck.length - 1].special !== 'slot' &&
            canPickUpDeck({ idDeck: 'right' }, 2)
          ) {
            pickUpDeck('right', setPlayer2Cards, 2);
          }
        } else {
          if (
            rightDeck[rightDeck.length - 1].special !== 'slot' &&
            canPickUpDeck({ idDeck: 'right' }, 2)
          ) {
            pickUpDeck('right', setPlayer2Cards, 2);
          } else if (
            leftDeck[leftDeck.length - 1].special !== 'slot' &&
            canPickUpDeck({ idDeck: 'left' }, 2)
          ) {
            pickUpDeck('left', setPlayer2Cards, 2);
          }
        }
      }
    };

    setRound(false);
    if (player2Deck.some(card => card.special === 'slot')) {
      console.log('fill');
      fillDeck();
    } else {
      const rand = Math.random();
      if (rand < 0.3) {
        console.log('check', rand);
        check();
      } else {
        console.log('play', rand);
        play();
      }
    }
  }, [
    round,
    enabled,
    player2Cards,
    setPlayer2Cards,
    player2Deck,
    setPlayer2Deck,
    leftDeck,
    setLeftDeck,
    rightDeck,
    setRightDeck,
    canMoveToDeck,
    moveToDeck,
    canMoveToGameDeck,
    moveToGameDeck,
    canPickUpDeck,
    pickUpDeck,
    status,
    pushXimiXurri,
    isXimiXurri
  ]);

  return enabled;
}
